import { render, staticRenderFns } from "./TravelerDialog.vue?vue&type=template&id=82123f12&"
import script from "./TravelerDialog.vue?vue&type=script&lang=js&"
export * from "./TravelerDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports